import ClientManageFiles from "Dashboard/Dashboardpages/ClientManageFiles";
import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import { authService } from "services";

function NumberVerifyOtp({ show, handleClose, user, setUser, updatedPhone }) {
  const [error, setError] = useState(null);
  const [otp, setOtp] = useState({});
  const [message, setMessage] = useState(null);

  const handleOTPChange = (e) => {
    setOtp({
      ...otp,
      [e.target.name]: e.target.value,
    });
    if (e.target.nextSibling && e.target.value) {
      e.target.nextSibling.focus();
    }
  };

  const handleRequestOtp = async () => {
    const payload = {
      type: "CHANGE_PHONE",
      roleType: user?.roleType,
      countryCode: user?.countryCode,
      phone: updatedPhone,
    };
    try {
      const response = await authService.requestotpAgain(payload);
      setMessage(response?.data?.message);
      setTimeout(() => setMessage(null), 2000);
    } catch (err) {
      console.log(err);
    }
  };

  const handleVerify = async () => {
    const otpData = Object.values(otp).filter((item) => item);
    if (otpData.length !== 4) {
      setError("Please enter otp");
      return;
    }
    setError(null);
    const payload = {
      type: "CHANGE_PHONE",
      phone: updatedPhone,
      roleType: user?.roleType,
      otp: otpData.join(""),
      deviceToken: "",
      roleType: user?.roleType,
    };
    try {
      const response = await authService.verifyotp(payload);
      const userData = response?.data?.data;
      if (userData?.token) {
        setUser(userData);
        localStorage.setItem("userData", JSON.stringify(userData));
        localStorage.setItem("token", userData?.token);
        handleClose();
      }

      if (response?.data?.success === false) {
        toast.error(response?.data?.message);
      } else {
        toast.success(response?.data?.message);
      }
    } catch (err) {
      setError(err?.response?.data?.message);
    }
  };

  return (
    <>
      <Modal
        show={show}
        className="modal-common verify-otp-modal"
        onHide={handleClose}
      >
        <Modal.Body>
          <form>
            <div className="head-verify">
              <h4>Verify Number</h4>
              <p>A 4 digit code has been sent to mobile number.</p>
            </div>

            <div className="verification-code m-0">
              <div className="verification-code--inputs d-flex mt-4">
                <input
                  name="otp-1"
                  type="text"
                  maxLength={1}
                  onKeyUp={handleOTPChange}
                />
                <input
                  name="otp-2"
                  type="text"
                  maxLength={1}
                  onKeyUp={handleOTPChange}
                />
                <input
                  name="otp-3"
                  type="text"
                  maxLength={1}
                  onKeyUp={handleOTPChange}
                />
                <input
                  name="otp-4"
                  type="text"
                  maxLength={1}
                  onKeyUp={handleOTPChange}
                />
              </div>
            </div>
            {error && <div className="text-danger text-center">{error}</div>}
            {message && (
              <div className="text-success text-center">{message}</div>
            )}

            <button
              type="button"
              className="btn d-inline-block btn-primary modal-blue-btn text-capitalize w-100 text-white"
              onClick={handleVerify}
            >
              Verify code
            </button>

            <p className="text-center light-text text-white mt-0 pt-4">
              Didn’t receive code?
              <button
                type="button"
                className="bg-transparent border-0 text-decoration-none fw-normal text-white"
                onClick={handleRequestOtp}
              >
                Request Again
              </button>
            </p>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default NumberVerifyOtp;
